import React from 'react';
import {
    Box,
    Card,
    Fade,
    Paper,
    Typography,
} from '@mui/material';
import { Security as SecurityIcon } from '@mui/icons-material';
import ApprovedRejectedList from './ApprovedRejectedList';
import TableHeaderTitle from '../../../components/TableHeaderTitle';
import { usePermission } from '../../../hooks/usePermission';

const ApprovedRejectedPage: React.FC = () => {
     // Permission kontrolü
        const { hasPermission: canViewApprovalList, isLoading: isPermissionLoading } = usePermission({
            code: 'Corporate.POST.Reading.Onay/RedListesineErişim'
        });

      // Eğer yetki yüklendi ve onay listesi görüntüleme yetkisi yoksa uyarı göster (yüklenirken tablo + skeleton gösterilir)
    if (!isPermissionLoading && !canViewApprovalList) {
        return (
            <Box sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Card sx={{
                    maxWidth: 500,
                    p: 4,
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(239, 68, 68, 0.1)',
                    background: 'rgba(255,255,255,0.9)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(252, 165, 165, 0.3)',
                    textAlign: 'center'
                }}>
                    <SecurityIcon sx={{ fontSize: 64, color: '#ef4444', mb: 3 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#dc2626', mb: 2 }}>
                        Erişim Engellendi
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#7f1d1d', lineHeight: 1.6 }}>
                        Bu sayfaya erişim yetkiniz bulunmamaktadır. Sistem yöneticinizle iletişime geçiniz.
                    </Typography>
                </Card>
            </Box>
        );
    }

    return (
        <Box sx={{
            padding: { xs: '85px 8px 0 8px', sm: '85px 12px 0 12px', md: '85px 32px 0 32px', lg: '85px 40px 0 40px' },
            background: 'linear-gradient(135deg, rgba(30, 60, 114, 0.03) 0%, rgba(42, 82, 152, 0.06) 100%)',
            borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
            minHeight: '100vh'
        }}>
            <Fade in={true} timeout={600}>
                <Box sx={{ px: 0 }}>
                    <Paper
                        elevation={0}
                        sx={{
                            mt: { xs: 2, sm: 3 },
                            borderRadius: 3,
                            background: 'rgba(255,255,255,0.7)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(226, 232, 240, 0.8)',
                            overflow: 'hidden',
                            position: 'relative',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '6px',
                                background: 'linear-gradient(90deg, #1e3c72 0%, #2a5298 25%, #3b82f6 50%, #2a5298 75%, #1e3c72 100%)',
                            }
                        }}
                    >
                        {/* Table Header */}
                        <Box sx={{
                            p: { xs: 2, sm: 3 },
                            pb: 2,
                            background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.9) 100%)',
                            borderBottom: '1px solid rgba(226, 232, 240, 0.6)'
                        }}>
                            <TableHeaderTitle title="Onayladıklarım / Reddettiklerim" />
                        </Box>

                        {/* Table Content */}
                        <Box sx={{ p: { xs: 2, sm: 3 } }}>
                            <ApprovedRejectedList />
                        </Box>
                    </Paper>
                </Box>
            </Fade>
        </Box>

    );
};

export default ApprovedRejectedPage;
